module.exports = __webpack_public_path__ + "img/supervisor-intro-five.39699e99.png";